
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { SubscriptionConfigRequest } from '../entities/subscription-config-v2/subscription-config-request';
import { axiosInstance } from "../axios-instance";

class SubscriptionConfigurationV2 {
  private authClient: OAuth2Client | null;

  private baseUrlV2: string;

  constructor(authClient: OAuth2Client | null, baseUrlV2: string) {
    this.authClient = authClient;
    this.baseUrlV2 = baseUrlV2;
  }

  queueSubscriptionConfiguration(
    input: SubscriptionConfigRequest,
  ): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrlV2}/queueConfigs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

}

export default SubscriptionConfigurationV2;
